/**
 * Access nested object keys through dot notation
 * @param path The path to lookup - 'key1.key2'
 * @param obj The nested object to lookup
 */

export const deepObject = (path: string, obj: any) => path.split('.').reduce((o, i) => o[i], obj)
